import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_item_category_RowClass} from '../../../dbschema';

export class ClaimItemCategoryContainerModel extends BaseContainerModel {
  bl_aat_claim_item_category: bl_aat_claim_item_category_RowClass = new bl_aat_claim_item_category_RowClass();
}
